module.exports = __webpack_public_path__ + "static/media/pix.81a02fb7.png";